const timestamp = (value) => {
  const date = value?.toDate ? value.toDate() : new Date(value || NaN);
  return date.getTime();
};
const monthOf = (value) => {
  const ms = timestamp(value);
  if (!Number.isFinite(ms)) return "";
  const parts = new Intl.DateTimeFormat("en-GB", { timeZone: "Europe/London", year: "numeric", month: "2-digit" }).formatToParts(new Date(ms));
  return `${parts.find((part) => part.type === "year").value}-${parts.find((part) => part.type === "month").value}`;
};

// Use the last recorded rate in the selected month, or carry an earlier rate forward.
export const monthlyFeeAtMonth = (current, logs, month) => {
  const ordered = logs.filter((log) => monthOf(log.updatedAt || log.editedAt))
    .sort((a, b) => timestamp(a.updatedAt || a.editedAt) - timestamp(b.updatedAt || b.editedAt));
  const latest = ordered.filter((log) => monthOf(log.updatedAt || log.editedAt) <= month).pop();
  if (latest?.rates && Object.prototype.hasOwnProperty.call(latest.rates, "monthlyFees")) return latest.rates.monthlyFees;
  const currentMonth = monthOf(current.updatedAt);
  if (currentMonth && currentMonth <= month) return current.monthlyFees;
  // A later edit records the fee before that change, even without an older snapshot.
  for (const log of ordered.filter((entry) => monthOf(entry.updatedAt || entry.editedAt) > month)) {
    const change = (log.changes || []).find((entry) => entry.fieldPath === "monthlyFees");
    if (change && Object.prototype.hasOwnProperty.call(change, "previousValue")) return change.previousValue;
  }
  return null;
};

export const monthlyFeeForIncomePeriod = (
  current,
  logs,
  month,
  { isOpen = false, closedAt = null } = {},
) => {
  if (isOpen) return current.monthlyFees;

  const cutoff = timestamp(closedAt);
  if (!Number.isFinite(cutoff)) return monthlyFeeAtMonth(current, logs, month);

  const ordered = logs.filter((log) => Number.isFinite(timestamp(log.updatedAt || log.editedAt)))
    .sort((a, b) => timestamp(a.updatedAt || a.editedAt) - timestamp(b.updatedAt || b.editedAt));
  const afterClosure = ordered.filter(
    (entry) => timestamp(entry.updatedAt || entry.editedAt) > cutoff,
  );
  if (afterClosure.length) {
    let value = current.monthlyFees;
    [...afterClosure].reverse().forEach((log) => {
      const change = (log.changes || []).find(
        (entry) => entry.fieldPath === "monthlyFees",
      );
      if (change && Object.prototype.hasOwnProperty.call(change, "previousValue")) {
        value = change.previousValue;
      }
    });
    return value === undefined || value === "" ? null : value;
  }
  const latest = ordered.filter(
    (log) => timestamp(log.updatedAt || log.editedAt) <= cutoff,
  ).pop();
  if (latest?.rates && Object.prototype.hasOwnProperty.call(latest.rates, "monthlyFees")) {
    return latest.rates.monthlyFees;
  }
  if (timestamp(current.updatedAt) <= cutoff) return current.monthlyFees;
  return null;
};

// Insight cards need a complete aggregate for comparison. Prefer the audited
// historical value, then carry the saved fee backwards for legacy records that
// pre-date rate history tracking.
export const monthlyFeeForComparison = (current = {}, logs = [], month, policy) => {
  const historicalFee = monthlyFeeForIncomePeriod(current, logs, month, policy);
  if (historicalFee !== null && historicalFee !== "" && historicalFee !== undefined) {
    return historicalFee;
  }
  return current.monthlyFees === "" || current.monthlyFees === undefined
    ? null
    : current.monthlyFees;
};
